import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e95cf9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog" }

import { useDialog } from '@/stores/dialogStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogContainer',
  setup(__props) {

const dialogStore = useDialog();
const DialogContent = dialogStore.dialogContent;
const dialogContentData = dialogStore.dialogContentData;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(DialogContent)), { data: _unref(dialogContentData) }, null, 8, ["data"]))
  ]))
}
}

})